var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrivacyPolicyImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 378,
    height: 263,
    viewBox: "0 0 378 263",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_n_96_668)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.278 111.229C179.824 92.898 198.321 71.3349 208.389 51.3008C218.465 31.2518 220.068 12.8101 210.981 0.641553C201.893 -11.527 183.756 -15.2263 161.671 -11.2576C139.602 -7.2919 113.674 4.32062 89.1283 22.6517C64.5821 40.9828 46.0849 62.5469 36.0164 82.5811C25.9405 102.63 24.3384 121.071 33.4257 133.24C42.5133 145.408 60.6503 149.108 82.735 145.14C104.804 141.174 130.732 129.56 155.278 111.229Z",
    stroke: "url(#paint0_linear_96_668)",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.358 126.059C190.904 107.728 209.401 86.165 219.47 66.1309C229.546 46.0819 231.148 27.6402 222.061 15.4716C212.973 3.3031 194.836 -0.396249 172.751 3.57243C150.682 7.53818 124.754 19.1507 100.208 37.4817C75.6621 55.8128 57.165 77.377 47.0964 97.4112C37.0206 117.46 35.4184 135.901 44.5058 148.07C53.5934 160.238 71.7304 163.938 93.8151 159.97C115.884 156.004 141.812 144.39 166.358 126.059Z",
    fill: "url(#paint1_linear_96_668)",
    stroke: "url(#paint2_linear_96_668)",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.43 140.889C201.976 122.558 220.473 100.995 230.542 80.961C240.618 60.9119 242.22 42.4702 233.133 30.3017C224.046 18.1332 205.908 14.4338 183.823 18.4025C161.755 22.3683 135.827 33.9808 111.281 52.3118C86.7344 70.6429 68.2373 92.207 58.1687 112.241C48.0929 132.29 46.4907 150.732 55.5781 162.9C64.6656 175.068 82.8027 178.768 104.887 174.8C126.956 170.834 152.884 159.22 177.43 140.889Z",
    fill: "url(#paint3_linear_96_668)",
    stroke: "url(#paint4_linear_96_668)",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.508 155.718C213.054 137.387 231.551 115.824 241.62 95.7896C251.696 75.7406 253.299 57.2989 244.211 45.1303C235.124 32.9618 216.986 29.2624 194.901 33.2311C172.833 37.1969 146.905 48.8094 122.359 67.1404C97.8125 85.4715 79.3154 107.036 69.2468 127.07C59.171 147.119 57.5688 165.56 66.6562 177.729C75.7437 189.897 93.8808 193.597 115.966 189.628C138.034 185.663 163.962 174.049 188.508 155.718Z",
    fill: "url(#paint5_linear_96_668)",
    stroke: "url(#paint6_linear_96_668)",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.581 170.548C224.126 152.217 242.624 130.654 252.692 110.62C262.768 90.5711 264.371 72.1294 255.284 59.9609C246.196 47.7924 228.059 44.093 205.974 48.0617C183.905 52.0274 157.977 63.64 133.431 81.971C108.885 100.302 90.3876 121.866 80.3191 141.9C70.2433 161.949 68.6411 180.391 77.7285 192.559C86.816 204.727 104.953 208.428 127.038 204.459C149.106 200.493 175.034 188.879 199.581 170.548Z",
    fill: "url(#paint7_linear_96_668)",
    stroke: "url(#paint8_linear_96_668)",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.653 185.378C235.199 167.047 253.696 145.484 263.764 125.45C273.84 105.401 275.443 86.9595 266.356 74.791C257.268 62.6224 239.131 58.9231 217.046 62.8918C194.977 66.8575 169.049 78.47 144.503 96.8011C119.957 115.132 101.46 136.696 91.3914 156.731C81.3155 176.78 79.7134 195.221 88.8007 207.389C97.8883 219.557 116.025 223.258 138.11 219.289C160.179 215.323 186.107 203.709 210.653 185.378Z",
    fill: "url(#paint9_linear_96_668)",
    stroke: "url(#paint10_linear_96_668)",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.733 200.207C246.279 181.876 264.776 160.313 274.845 140.279C284.921 120.23 286.523 101.789 277.436 89.6201C268.348 77.4515 250.211 73.7522 228.126 77.7209C206.057 81.6866 180.129 93.2991 155.583 111.63C131.037 129.961 112.54 151.525 102.471 171.56C92.3956 191.609 90.7934 210.05 99.8808 222.218C108.968 234.387 127.105 238.087 149.19 234.118C171.259 230.152 197.187 218.539 221.733 200.207Z",
    fill: "url(#paint11_linear_96_668)",
    stroke: "url(#paint12_linear_96_668)",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.805 215.038C257.351 196.707 275.848 175.143 285.917 155.109C295.993 135.06 297.595 116.619 288.508 104.45C279.421 92.2816 261.283 88.5823 239.198 92.5509C217.13 96.5167 191.202 108.129 166.656 126.46C142.109 144.791 123.612 166.355 113.544 186.39C103.468 206.439 101.866 224.88 110.953 237.048C120.041 249.217 138.178 252.917 160.262 248.948C182.331 244.982 208.259 233.369 232.805 215.038Z",
    fill: "url(#paint13_linear_96_668)",
    stroke: "url(#paint14_linear_96_668)",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.879 229.868C268.425 211.537 286.922 189.974 296.991 169.939C307.067 149.89 308.67 131.449 299.582 119.28C290.495 107.112 272.357 103.412 250.272 107.381C228.204 111.347 202.276 122.959 177.73 141.29C153.184 159.621 134.686 181.186 124.618 201.22C114.542 221.269 112.94 239.71 122.027 251.878C131.115 264.047 149.252 267.747 171.337 263.778C193.405 259.813 219.333 248.199 243.879 229.868Z",
    fill: "url(#paint15_linear_96_668)",
    stroke: "url(#paint16_linear_96_668)",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.956 244.696C279.501 226.365 297.999 204.802 308.067 184.768C318.143 164.719 319.746 146.277 310.659 134.109C301.571 121.94 283.434 118.241 261.349 122.21C239.28 126.175 213.352 137.788 188.806 156.119C164.26 174.45 145.763 196.014 135.694 216.048C125.618 236.097 124.016 254.539 133.103 266.707C142.191 278.875 160.328 282.575 182.413 278.607C204.481 274.641 230.409 263.027 254.956 244.696Z",
    fill: "url(#paint17_linear_96_668)",
    stroke: "url(#paint18_linear_96_668)",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.032 259.527C290.578 241.196 309.075 219.633 319.143 199.599C329.219 179.55 330.822 161.108 321.735 148.939C312.647 136.771 294.51 133.072 272.425 137.04C250.356 141.006 224.428 152.618 199.882 170.95C175.336 189.281 156.839 210.845 146.77 230.879C136.694 250.928 135.092 269.369 144.18 281.538C153.267 293.706 171.404 297.406 193.489 293.437C215.557 289.472 241.486 277.858 266.032 259.527Z",
    fill: "url(#paint19_linear_96_668)",
    stroke: "url(#paint20_linear_96_668)",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.104 274.355C301.65 256.024 320.147 234.461 330.216 214.427C340.292 194.378 341.894 175.936 332.807 163.768C323.72 151.599 305.582 147.9 283.497 151.868C261.428 155.834 235.501 167.447 210.954 185.778C186.408 204.109 167.911 225.673 157.843 245.707C147.767 265.756 146.165 284.197 155.252 296.366C164.339 308.534 182.477 312.234 204.561 308.266C226.63 304.3 252.558 292.686 277.104 274.355Z",
    fill: "url(#paint21_linear_96_668)",
    stroke: "url(#paint22_linear_96_668)",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.174 289.184C312.72 270.854 331.217 249.29 341.286 229.256C351.362 209.207 352.965 190.766 343.877 178.597C334.79 166.429 316.652 162.729 294.567 166.698C272.499 170.664 246.571 182.276 222.025 200.607C197.479 218.938 178.981 240.502 168.913 260.537C158.837 280.586 157.235 299.027 166.322 311.195C175.41 323.364 193.547 327.064 215.632 323.095C237.7 319.129 263.628 307.516 288.174 289.184Z",
    stroke: "url(#paint23_linear_96_668)",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_n_96_668",
    x: 27.1995,
    y: -13.0347,
    width: 322.904,
    height: 337.906,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "2 2",
    stitchTiles: "stitch",
    numOctaves: 3,
    result: "noise",
    seed: 9600
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "noise",
    type: "luminanceToAlpha",
    result: "alphaNoise"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "alphaNoise",
    result: "coloredNoise1"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "discrete",
    tableValues: "1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
  })), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "shape",
    in: "coloredNoise1",
    result: "noise1Clipped"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(0, 0, 0, 0.25)",
    result: "color1Flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "noise1Clipped",
    in: "color1Flood",
    result: "color1"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect1_noise_96_668"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shape"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "color1"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_96_668",
    x1: 52.4696,
    y1: 30.9792,
    x2: 224.924,
    y2: 18.5725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#088579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#088579",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_96_668",
    x1: 223.88,
    y1: -21.1084,
    x2: 273.109,
    y2: 88.2963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#088579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927083,
    stopColor: "#002E2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_96_668",
    x1: 166.507,
    y1: 126.259,
    x2: 100.059,
    y2: 37.2815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#088579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#088579",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_96_668",
    x1: 234.952,
    y1: -6.27836,
    x2: 284.181,
    y2: 103.126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#088579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927083,
    stopColor: "#002E2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_96_668",
    x1: 177.58,
    y1: 141.089,
    x2: 111.131,
    y2: 52.1116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#088579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#088579",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_96_668",
    x1: 246.03,
    y1: 8.55025,
    x2: 295.259,
    y2: 117.955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#088579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927083,
    stopColor: "#002E2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_96_668",
    x1: 188.658,
    y1: 155.918,
    x2: 122.209,
    y2: 66.9402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#088579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#088579",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_96_668",
    x1: 257.103,
    y1: 23.3808,
    x2: 306.331,
    y2: 132.786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#088579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927083,
    stopColor: "#002E2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_96_668",
    x1: 199.73,
    y1: 170.749,
    x2: 133.281,
    y2: 81.7708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#088579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#088579",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_96_668",
    x1: 268.175,
    y1: 38.2109,
    x2: 317.404,
    y2: 147.616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#088579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927083,
    stopColor: "#002E2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_96_668",
    x1: 210.802,
    y1: 185.579,
    x2: 144.354,
    y2: 96.6009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#088579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#088579",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_96_668",
    x1: 279.255,
    y1: 53.04,
    x2: 328.484,
    y2: 162.445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#088579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927083,
    stopColor: "#002E2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_96_668",
    x1: 221.882,
    y1: 200.408,
    x2: 155.434,
    y2: 111.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#088579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#088579",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_96_668",
    x1: 290.327,
    y1: 67.8701,
    x2: 339.556,
    y2: 177.275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#088579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927083,
    stopColor: "#002E2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_96_668",
    x1: 232.955,
    y1: 215.238,
    x2: 166.506,
    y2: 126.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#088579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#088579",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_96_668",
    x1: 301.402,
    y1: 82.7002,
    x2: 350.63,
    y2: 192.105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#088579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927083,
    stopColor: "#002E2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_96_668",
    x1: 244.029,
    y1: 230.068,
    x2: 177.58,
    y2: 141.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#088579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#088579",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_96_668",
    x1: 312.478,
    y1: 97.5288,
    x2: 361.706,
    y2: 206.933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#088579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927083,
    stopColor: "#002E2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_96_668",
    x1: 255.105,
    y1: 244.897,
    x2: 188.656,
    y2: 155.919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#088579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#088579",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_96_668",
    x1: 323.554,
    y1: 112.359,
    x2: 372.782,
    y2: 221.764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#088579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927083,
    stopColor: "#002E2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_96_668",
    x1: 266.181,
    y1: 259.727,
    x2: 199.733,
    y2: 170.749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#088579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#088579",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_96_668",
    x1: 334.626,
    y1: 127.187,
    x2: 383.855,
    y2: 236.592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#088579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927083,
    stopColor: "#002E2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_96_668",
    x1: 277.253,
    y1: 274.555,
    x2: 210.805,
    y2: 185.577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#088579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#088579",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_96_668",
    x1: 219.379,
    y1: 169.721,
    x2: 312.62,
    y2: 332.853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#088579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#088579",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacyPolicyImg);
export default __webpack_public_path__ + "static/media/PrivacyPolicyImg.cbbe46e707b93284deb912dcc61aac4d.svg";
export { ForwardRef as ReactComponent };